<template>
  <v-form
    v-if="id && shift"
    v-model="valid"
    class="py-8 bg-light-blue-main">
    <div class="pa-4">
      <v-container class="bordered bg-white">
        <NormalInput
          :id="id"
          class="mb-4"
          field="name" />
        <NormalInput
          :id="id"
          class="mb-4"
          field="description" />
      </v-container>

      <nonWageLaborCostTablePart
        class="bordered bg-white"
        :shift-id="id" />

      <v-container class="bordered bg-white mt-4">
        <v-row class="mt-0 px-4">
          <v-col
            class="pt-2 text-body-2"
            cols="3">
            {{ $t("entities.shift.fields.mandatory_charges_percentage_shift") }}
          </v-col>
          <v-col
            class="py-0 pr-14"
            cols="2">
            <v-text-field
              v-model="shift.mandatory_charges_percentage_shift"
              class="mb-4"
              readonly
              suffix=" %"
              variant="filled"
              width="150" />
          </v-col>
        </v-row>
        <v-row class="mt-0 px-4">
          <v-col
            class="pt-2 text-body-2"
            cols="3">
            {{ $t("entities.shift.fields.voluntary_charges_percentage_shift") }}
          </v-col>
          <v-col
            class="py-0 pr-14"
            cols="2">
            <v-text-field
              v-model="shift.voluntary_charges_percentage_shift"
              class="mb-4"
              readonly
              suffix=" %"
              variant="filled"
              width="150" />
          </v-col>
        </v-row>
        <v-row class="mt-0 px-4">
          <v-col
            class="pt-2 text-body-2"
            cols="3">
            {{
              $t(
                "entities.shift.fields.non_wage_labour_cost_surcharge_percentage_shift"
              )
            }}
          </v-col>
          <v-col
            class="py-0 pr-14"
            cols="2">
            <v-text-field
              v-model="shift.non_wage_labour_cost_surcharge_percentage_shift"
              class="mb-4"
              readonly
              suffix=" %"
              variant="filled"
              width="150" />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-form>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
import nonWageLaborCostTablePart from "./NonWageLaborCostTable.vue";
import { useSpaceStore } from "@/stores/spaceStore";
import NormalInput from "@/components/Elements/NormalInput.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();

const valid = ref(false);

// Form fields, only for validation
const shift = ref(null);
const { required } = useCommonRules(t);

const props = defineProps({
  closeDialog: {
    type: Function,
    required: true
  },
  id: {
    type: String,
    required: true
  }
});

const route = useRoute();

const id = computed(() => route.params.nodeId);

onMounted(() => {
  shift.value = spaceStore.getElement(id.value);
});
</script>

<style>
.v-form {
  max-height: 100%;
  overflow: auto;
  background-color: white;
}
</style>
